module.exports = __webpack_public_path__ + "static/media/kn.bde74c6d.svg";